import React from 'react';
import { Card, CardHead, Pill } from '../components/UI';
import s from './Validation.module.css';

const CHECKS = [
  { type:'pass', text:'GST number validated against GSTN portal', label:'Pass', labelColor:'var(--accent)' },
  { type:'pass', text:'PO reference matched — ₹18.4 L within limit', label:'Pass', labelColor:'var(--accent)' },
  { type:'pass', text:'Bank account matches registered supplier record', label:'Pass', labelColor:'var(--accent)' },
  { type:'warn', text:'Delivery certificate submitted as scanned copy (not original)', label:'Advisory', labelColor:'var(--warn)' },
  { type:'pass', text:'No duplicate invoice detected in last 90 days', label:'Pass', labelColor:'var(--accent)' },
  { type:'pass', text:'Freight charges within agreed rate card', label:'Pass', labelColor:'var(--accent)' },
];

export default function Validation() {
  return (
    <div>
      <div className={s.grid}>
        <div>
          <Card>
            <CardHead title="INV-2024-1183 — Bharat Petro Supplies"
              action={<Pill type="ready">AI validated</Pill>} />
            <div className={s.invDetail}>
              {[
                ['Invoice date','02 Jul 2026'],
                ['Invoice amount','₹18,40,000'],
                ['GSTIN','33AABCB1234F1ZX'],
                ['PO reference','PO-CPCL-2024-881'],
                ['Bank account','ICICI ****4421'],
                ['OCR confidence',<span style={{color:'var(--accent)'}}>98.4%</span>],
              ].map(([k,v],i) => (
                <div key={i} className={s.invField}>
                  <div className={s.flab}>{k}</div>
                  <div className={s.fval}>{v}</div>
                </div>
              ))}
            </div>
            <div>
              {CHECKS.map((c,i) => (
                <div key={i} className={s.checkRow}>
                  <div className={`${s.chk} ${s['chk_'+c.type]}`}>
                    {c.type === 'pass' ? '✔' : c.type === 'fail' ? '✘' : '!'}
                  </div>
                  <span style={{flex:1}}>{c.text}</span>
                  <span style={{color:c.labelColor,fontSize:11,flexShrink:0}}>{c.label}</span>
                </div>
              ))}
            </div>
          </Card>
        </div>

        <div>
          <Card style={{marginBottom:12}}>
            <CardHead title="Invoice scores" />
            <div className={s.scoreRow}>
              <div className={s.scoreBox}>
                <span className={s.sval} style={{color:'var(--accent)'}}>94</span>
                <span className={s.slbl}>Compliance</span>
              </div>
              <div className={s.scoreBox}>
                <span className={s.sval} style={{color:'#4dd6a0'}}>12</span>
                <span className={s.slbl}>Fraud risk</span>
              </div>
              <div className={s.scoreBox}>
                <span className={s.sval} style={{color:'var(--accent)'}}>97</span>
                <span className={s.slbl}>Pay readiness</span>
              </div>
            </div>
            <div style={{marginTop:12}}>
              <div style={{fontSize:11,color:'var(--muted)',marginBottom:6}}>Fraud risk meter</div>
              <div className={s.riskMeter}>
                <div className={s.riskNeedle} style={{left:'12%'}} />
              </div>
              <div style={{display:'flex',justifyContent:'space-between',fontSize:10,color:'var(--muted)'}}>
                <span>Low</span><span>Medium</span><span>High</span>
              </div>
            </div>
          </Card>

          <Card>
            <CardHead title="AI recommendation" />
            <div className={s.aiBox}>
              <div className={s.aiTitle}><i className="ti ti-robot" /> Finigenie AI verdict</div>
              <div className={s.aiText}>
                Invoice meets all mandatory validation criteria. Delivery certificate submitted as scanned copy — recommend approval with note. No fraud signals detected.
              </div>
            </div>
            <div style={{display:'flex',gap:8,marginTop:10}}>
              <button className={s.btnApprove}><i className="ti ti-circle-check" /> Approve</button>
              <button className={s.btnFlag}><i className="ti ti-message" /> Flag</button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
